import '.bi{max-width:480px;}.ssr-plugin'
import '.es{margin-left:8px;}.ssr-plugin'
import '.et{margin-right:8px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.fq{height:calc(100% - 128px);}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.fr{border-top-left-radius:24px;}.ssr-plugin'
import '.fs{border-top-right-radius:24px;}.ssr-plugin'
import '.d6{aspect-ratio:1/1;}.ssr-plugin'
import '.cf{top:0px;}.ssr-plugin'
import '.ag{left:0px;}.ssr-plugin'
import '.k{height:100%;}.ssr-plugin'
import '.ey{overflow-y:scroll;}.ssr-plugin'
import '.ac{scrollbar-width:none;}.ssr-plugin'
import '.ft{padding:72px 72px;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.bm{margin-bottom:48px;}.ssr-plugin'
import '.s{max-width:240px;}.ssr-plugin'
import '.ba{object-fit:cover;}.ssr-plugin'
import '.de{display:block;}.ssr-plugin'
import '.fu{user-select:none;}.ssr-plugin'
import '.fv{-webkit-user-select:none;}.ssr-plugin'
import '.fw{-moz-user-select:none;}.ssr-plugin'
import '.v{border-radius:16px;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.fx{text-align:center !important;}.ssr-plugin'
import '.df{margin-top:8px;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.cv{flex-direction:row;}.ssr-plugin'
import '.g{gap:8px;}.ssr-plugin'
import '.fy{font-size:18px;}.ssr-plugin'
import '.fz{margin-top:2px;}.ssr-plugin'
import '.g0{margin-top:48px;}.ssr-plugin'
import '.g1{max-width:374px;}.ssr-plugin'
import '.g2{direction:ltr;}.ssr-plugin'
import { useRef, useState } from 'react'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { IconButton } from './IconButton.js'
import { Icon } from '../assets/icons/index.js'
import { VoteButton } from './VoteButton.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { Flag } from './Flag.js'
import { getVotingRegionName } from '../hooks/useVotingRegion.js'
import { useContentQuery } from '../ctx.js'
import { MOBILE } from '../utils/breakpoints.js'

const SLIDE_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)'
const SLIDE_DURATION = '800ms'

export const ContestantModal = ({
  setModal,
  contestant,
  modalIndex,
  setModalIndex,
  amountOfContestants,
  votes,
  setVotes,
  maxed,
  rtl,
  lang,
}) => {
  const { name, img, song, votingRegion, id } = contestant
  const [direction, setDirection] = useState<'next' | 'prev' | null>(null)
  const [outgoing, setOutgoing] = useState<{
    contestant: typeof contestant
    direction: 'next' | 'prev'
  } | null>(null)

  const { data: lyrics, loading, error } = useContentQuery('lyrics', id, true)
  const lastLyricsRef = useRef<string>('')
  if (lyrics) lastLyricsRef.current = lyrics
  const displayLyrics = lyrics ?? lastLyricsRef.current

  const slideInAnimation =
    direction === 'next'
      ? `step-slide-in-right ${SLIDE_DURATION} ${SLIDE_EASING} both`
      : direction === 'prev'
        ? `step-slide-in-left ${SLIDE_DURATION} ${SLIDE_EASING} both`
        : undefined

  const switchTo = (newIndex: number, dir: 'next' | 'prev') => {
    setOutgoing({ contestant, direction: dir })
    setDirection(dir)
    setModalIndex(newIndex)
  }

  const goPrev = () => {
    switchTo(modalIndex <= 0 ? amountOfContestants - 1 : modalIndex - 1, 'prev')
  }

  const goNext = () => {
    switchTo(modalIndex >= amountOfContestants - 1 ? 0 : modalIndex + 1, 'next')
  }

  return (
    <ModalWrapper
      onDismiss={() => {
        setModal(false)
      }}
    >
      <styled.article className="bi es et m fq cx ai c2 b1"
        id="voting-page-contestant-modal"
        style={{
          backgroundColor: transparentColor(colors.primary, 0.9),
          border: `1px solid ${colors.border}`,
          animation: MODAL_PANEL_ANIMATION,
          [MOBILE]: {
            height: 'calc(100% - 16px)',
          },
        }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
      >
        <div className="a6 fr fs d6 m cf ag"
        />
        <IconButton
          ariaLabel="close-contestant-modal"
          id="voting-page-contestant-modal-action-close-modal"
          variant="ghost"
          size="large"
          icon={<Icon type="closeIcon" />}
          onClick={() => setModal(false)}
          style={{
            position: 'absolute',
            top: 12,
            right: rtl ? 'unset' : 12,
            left: rtl ? 12 : 'unset',
            zIndex: 2,
          }}
        />
        <IconButton
          ariaLabel="previous"
          variant="ghost"
          size="large"
          icon={<Icon type="chevronLeftIcon" />}
          onClick={goPrev}
          style={{
            position: 'absolute',
            top: 167,
            left: 16,
            zIndex: 2,
            transform: rtl ? 'scaleX(-1)' : 'none',
          }}
        />
        <IconButton
          ariaLabel="next"
          variant="ghost"
          size="large"
          icon={<Icon type="chevronRightIcon" />}
          onClick={goNext}
          style={{
            position: 'absolute',
            top: 167,
            right: 16,
            zIndex: 2,
            transform: rtl ? 'scaleX(-1)' : 'none',
          }}
        />

        <div className="k ey ac ft b1 ai"
        >
          <div className="e w cy bm ai"
          >
            <div className="ai s m d6"
            >
              <img className="m k ba de d6 fu fv fw v"
                key={`img-${modalIndex}`}
                src={img}
                style={{
                  border: `1px solid ${colors.border}`,
                  animation: slideInAnimation,
                }}
              />
            </div>
          </div>
          {/* // content */}
          <div className="ai">
            <styled.div className="e f w ai fx"
              key={`content-${modalIndex}`}
              style={{
                animation: slideInAnimation,
                '& p': {
                  // @ts-ignore
                  textAlign: 'center !important',
                },
              }}
            >
              <h2 style={{ fontFamily: 'Singing-Sans' }}>{name}</h2>
              <div className="df bn e cv w g"
              >
                <Flag code={votingRegion} />
                <p className="fy fz">
                  {getVotingRegionName(votingRegion, lang.code)}
                </p>
              </div>
              <div>
                <VoteButton
                  id="voting-page-contestant-modal-action-vote-button"
                  votes={votes}
                  votingRegion={votingRegion}
                  setVotes={setVotes}
                  maxed={maxed}
                />
              </div>
              <h3 className="g0 bn"
              >
                {song}
              </h3>

              <div className="g1 m g2"
                dangerouslySetInnerHTML={{
                  __html: displayLyrics,
                }}
              />
            </styled.div>
          </div>
        </div>
      </styled.article>
    </ModalWrapper>
  )
}
